import React from "react";
import style from "./assessmentNotes.module.scss";
import { signedLockedAccess } from "../../../../utils";
import { ZoomPhoto } from "../Photos";
import NotesDeleteConfirmationModal from "./notesDeleteConfirmationModal";
import { useAssessmentNotes } from "./useAssessmentNotes";
import { StatusAlerts } from "./StatusAlerts";
import { NoteForm } from "./NoteForm";
import { NotesList } from "./NotesList";
import { SectionBanners } from "../../../secondary";
import { PERMISSIONS } from "../../../../constants/permissions";

export const AssessmentNotes = () => {
  const {
    register,
    handleSubmit,
    reset,
    doSubmit,
    notes,
    detailAssessment,
    measurementData,
    createNoteLoading,
    deleteAssessmentNoteState,
    assessmentNotesLoading,
    woundImageLoading,
    setWoundImageLoading,
    deleteConfirmationModal,
    setDeleteConfirmationModal,
    handleDeleteNote,
    handleDeleteAssessmentNote,
    canCreateAssessmentNote,
    hasPermission,
    handleEditClick,
    successMessage,
    updateNoteLoading,
    editNoteId,
    handleCancelEdit,
    handleSaveEdit,
    editedNote,
    onEditChange,
    onKeyDown,
  } = useAssessmentNotes();

  return (
    <div>
      <div className="row d-flex row no-gutters">
        <div className="col-4" style={{ overflow: "hidden" }}>
          <div className={style.patient_wound}>
            <ZoomPhoto
              image={measurementData?.assessedImageSASURL || measurementData?.intialImageSASURL || detailAssessment?.picture}
              loading={woundImageLoading}
              setLoading={setWoundImageLoading}
              showBottomBtn={false}
              classes={{
                outerClass: undefined,
                innerClass: "position-relative w-100",
                shimmerClass: style.image_skleton,
              }}
              showTopBtn={detailAssessment?.isWoundWithoutPhoto === 0}
            />
          </div>
        </div>

        <div className="col-8 w-100">
          <div className="ml-4">
            <SectionBanners requiredPermission={PERMISSIONS.ASSESSMENT_NOTE_CREATE} />
          </div>
          <div className={`${style.notes_conatiner} w-100`}>
            <StatusAlerts deleteAssessmentNoteState={deleteAssessmentNoteState} successMessage={successMessage} />

            <NoteForm register={register} handleSubmit={handleSubmit} doSubmit={doSubmit} reset={reset} loading={createNoteLoading} disabled={!canCreateAssessmentNote || !signedLockedAccess(detailAssessment?.assessmentStage)} />

            <NotesList
              notes={notes}
              assessmentStage={detailAssessment?.assessmentStage}
              onDeleteNote={handleDeleteAssessmentNote}
              hasPermission={hasPermission}
              handleEditClick={handleEditClick}
              editNoteId={editNoteId}
              handleCancelEdit={handleCancelEdit}
              handleSaveEdit={handleSaveEdit}
              editedNote={editedNote}
              onEditChange={onEditChange}
              onKeyDown={onKeyDown}
              updateNoteLoading={updateNoteLoading}
              assessmentNotesLoading={assessmentNotesLoading}
            />
          </div>
        </div>
      </div>

      {deleteConfirmationModal && <NotesDeleteConfirmationModal setDeleteModal={setDeleteConfirmationModal} handleDelete={handleDeleteNote} />}
    </div>
  );
};
